const jouwnetSettings = {
    jnStores: [
              {
                id: 'almere-01',
                label: 'Almere',
                store_url: 'https://kas20.nl/pages/meubel-showroom-bezoeken-almere',
                name: 'Showroom Almere',
                description: '<p class="description">Bekijk ons gehele assortiment</p>',
                address: 'Radioweg 12<br>1324 KW, Almere<br>Flevoland',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
                store_img: 'https://kas20.nl/cdn/shop/files/Frame_169_720x.jpg?v=1706176294',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/meubel-showroom-bezoeken-almere">Feestdagen</a>',
                times: [
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: 'gesloten',
                  //       bold: true,
                  //   },
                    // {
                    //     spacer: true
                    // },
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: 'gesloten',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '10.00 - 17.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },

                
                  
                    {
                        label: 'Ma',
                        time: '10.00 - 17.00',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '10.00 - 16.30',
                    // },
                    {
                        label: 'Di',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Wo',
                        time: 'gesloten',
                    },
                    {
                        label: 'Do',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Zo',
                        time: 'gesloten',
                    },

                    {
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },
                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '10.00 - 17.00',
                  //   },
                  // {
                  //       label: '1e Paasdag',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '12.00 - 17.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: 'Gesloten',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 17.00',
                  //       date: '05-05-2025'
                  //   },
                    
                    // {
                    //     label: '24-12) Di',
                    //     time: '10.00 - 16.00',
                    // },
                    // // {
                    // //     // label: '25-12) Wo',
                    // //     label: '1e kerstdag',
                    // //     time: 'gesloten',
                    // // },
                    // {
                    //     // label: '26-12) Do',
                    //     label: '2e kerstdag',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     label: '29-12) Zo',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '30-12) Ma',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12) Di',
                    //     label: 'Oudjaarsdag',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     // label: '01-01) Wo',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '05-01) Zo',
                    //     time: 'gesloten',
                    // },
  
                    {
                        spacer: true
                    },

                  
                    // {
                    //     paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                    // },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/6Uwj7K7YRjj7gPQB9" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/meubel-showroom-bezoeken-almere">Feestdagen</a>',
                        types: ['footer']
                    },
                ],
            },
              {
                id: 'de-kwakel-01',
                label: 'De Kwakel',
                store_url: 'https://kas20.nl/pages/showroom-bezoeken-de-kwakel',
                name: 'Showroom De Kwakel',
                description: '<p class="description">Bekijk ons gehele assortiment</p>',
                address: 'Noorddammerweg 35<br>1424 NW, De Kwakel<br>Noord-Holland',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_19_1296x.png?v=1650283399',
                // store_img: 'https://kas20.nl/cdn/shop/files/Ontwerp_zonder_tihtel_720x.jpg?v=1710249627',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/IMG_7536_0edc5f3c-29c8-4710-8ef9-47c9af8aaee2_720x.jpg?v=1735644714',
                // times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo gesloten <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 16.30 <br>Zo 11.00 - 13.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-de-kwakel">Feestdagen</a>',
                times: [
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '10.00 - 15.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '10.00 - 17.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '10.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
               
                    {
                        label: 'Ma',
                        time: '10.00 - 17.00',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '10.00 - 16.30',
                    // },
                    {
                        label: 'Di',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Wo',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Do',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 16.30',
                    },
                    {
                        label: 'Zo',
                        time: '11.00 - 15.00',
                    },

                     {
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },

                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '10.00 - 17.00',
                  //   },

                  // {
                  //       label: '1e Paasdag',
                  //       time: '11.00 - 15.00',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '10.00 - 16.30',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: '10.00 - 16.30',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 16.30',
                  //   },

                  // {
                  //       paragraph: 'Let op! i.v.m. marathon zijn we later geopend.',
                  //   },
                  //   {
                  //       label: '26-01) Zo',
                  //       time: '12.00 - 16.00',
                  //   },
                    // // {
                    // //     // label: '25-12-24 (1e)',
                    // //     label: '1e kerstdag',
                    // //     time: 'gesloten',
                    // // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12-24',
                    //     label: 'Oudjaarsdag',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     // label: '01-01-25',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    {
                        spacer: true
                    },
                  
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/tSqnHe9BW3R37sct6" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-de-kwakel">Feestdagen</a>',
                        types: ['footer']
                    },
                ],
            },
            {
                id: 'helmond-01',
                label: 'Helmond',
                store_url: 'https://kas20.nl/pages/showroom-bezoeken-helmond',
                name: 'Showroom Helmond',
                description: '<p class="description">Bekijk ons gehele assortiment</p>',
                address: 'Nijverheidsweg 12a<br>5705 BN, Helmond<br>Noord-Brabant',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
                store_img: 'https://kas20.nl/cdn/shop/files/Ontwerp_zonder_titel_720x.jpg?v=1710247751',
                // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vrij 12.00 - 16.00<br>Zat 10.00 - 16.00<br>Zo 12.00 - 16.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-helmond">Feestdagen</a>',
                times: [
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
  
                   
                  
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '11.00 - 15.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },
                    {
                        label: 'Ma',
                        // time: 'gesloten',
                        time: '10.00 - 17.00',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '10.00 - 16.00',
                    // },
                    {
                        label: 'Di',
                        time: 'gesloten',
                        // time: '11.00 - 15.00',
                    },
                    {
                        label: 'Wo',
                        // time: 'gesloten',
                      time: '12.00 - 16.00',
                    },
                    {
                        label: 'Do',
                        // time: 'gesloten',
                        time: '12.00 - 21.00',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 16.00',
                    },
                    {
                        label: 'Zo',
                        time: '12.00 - 16.00',
                    },

                    {
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },
                    //   {
                    //     label: 'Wo (26-02-25)',
                    //     time: '12.00 - 16.00',
                    // },

                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '12.00 - 16.00',
                  //   },

                  // {
                  //       label: '1e Paasdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (12-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (19-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (26-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                    // {
                    //     // label: '25-12-24 (1e)',
                    //     label: 'Ma (30-12-24)',
                    //     time: '11.00 - 16.00',
                    //     // time: 'gesloten',
                    // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12-24',
                    //     label: 'Oudjaarsdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     // label: '01-01-25',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    {
                        spacer: true
                    },
                  
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="https://goo.gl/maps/xDJtFf8jkohLCcbh7" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-helmond">Feestdagen</a>',
                        types: ['footer']
                    },
                ],
            },
            {
                id: 'enschede-01',
                label: 'Enschede',
                store_url: 'https://kas20.nl/pages/meubel-showroom-bezoeken-enschede',
                name: 'Showroom Enschede',
                description: '<p class="description">Bekijk ons gehele assortiment</p>',
                address: 'Lage Bothofstraat 159A<br>7533 AS, Enschede<br>Overijssel',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
                store_img: 'https://kas20.nl/cdn/shop/files/Scherm_afbeelding_2024-03-12_om_15.03.26_720x.png?v=1710252221',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-almere">Feestdagen</a>',
                times: [
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
                  
                    // {
                    //     paragraph: '<strong>Let op!</strong> Open vanaf 24 februari',
                    // },
                    // {
                    //     paragraph: '<strong>Let op!</strong> 25 februari gesloten',
                    // },
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '11.00 - 16.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },

               
                  
                    {
                        label: 'Ma',
                        time: 'Gesloten',
                        // time: '11.00 - 16.00',
                    },
                    // {
                    //     label: 'Ma',
                    //     time: '11.00 - 15.00 (2e Paasdag)',
                    // },
                    {
                        label: 'Di',
                        time: 'op afspraak',
                    },
                    {
                        label: 'Wo',
                        time: 'gesloten',
                    },
                    {
                        label: 'Do',
                        time: 'op afspraak',
                    },
                    {
                        label: 'Vr',
                        time: '11.00 - 15.00',
                    },
                    {
                        label: 'Za',
                        time: '11.00 - 16.00',
                    },
                    {
                        label: 'Zo',
                        time: '11.00 - 15.00',
                    },

                      {
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },

                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '11.00 - 15.00',
                  //   },
                  // {
                  //       label: '1e Paasdag',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '11.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       // time: '11.00 - 16.00',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '12.00 - 15.00',
                  //   },

                    // {
                    //     // label: '25-12-24 (1e)',
                    //     label: '1e kerstdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '11.00 - 16.00',
                    // },
                    // {
                    //     label: '27-12-24',
                    //     time: '11.00 - 15.00',
                    // },
                    // {
                    //     label: '28-12-24',
                    //     time: '11.00 - 16.00',
                    // },
                    // {
                    //     label: '29-12-24',
                    //     time: '11.00 - 15.00',
                    // },
                    {
                        spacer: true
                    },
                  // {
                  //       paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                  //   },
                  {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/QiiDNSBc5aJ52LaZ6" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/meubel-showroom-bezoeken-enschede">Feestdagen</a>',
                        types: ['footer']
                    },
                ]
            },
            // {
            //     id: 'amsterdam-01',
            //     label: 'Amsterdam',
            //     store_url: 'https://kas20.nl/pages/showroom-bezoeken-amsterdam',
            //     name: 'Showroom Amsterdam',
            //     description: '<p class="description">Bekijk ons assortiment eettafels</p>',
            //     address: 'Commelinstraat 11-0<br>1093 TE, Amsterdam<br>Noord-Holland',
            //     store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_20_1296x.png?v=1650283373',
            //     // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vr gesloten<br>Zat 10.00 - 17.00<br>1e zondag van de maand 12:00 - 16:00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-amsterdam">Feestdagen</a>',
            //     times: [
            //       // {
            //       //       spacer: true
            //       //   },
            //       //   {
            //       //       label: 'Koningsdag',
            //       //       time: 'gesloten',
            //       //       bold: true,
            //       //   },
            //       //   {
            //       //       spacer: true
            //       //   },

  
                  
            //         {
            //             label: 'Ma',
            //             time: 'gesloten',
            //             // time: '11.00 - 16.00',
            //         },
            //         {
            //             label: 'Di',
            //             time: 'gesloten',
            //         },
            //         {
            //             label: 'Wo',
            //             time: 'gesloten',
            //         },
            //         {
            //             label: 'Do',
            //             time: 'Gesloten',
            //         },
            //         {
            //             label: 'Vr',
            //             time: '10.00 - 17.00',
            //         },
            //       {
            //             label: 'Za',
            //             time: '10.00 - 17.00',
            //         },
            //       {
            //             label: 'Zo',
            //             time: 'Gesloten',
            //         },

                  
                  
            //           {
            //             paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
            //         },

            //       // {
            //       //       label: 'Goede vrijdag',
            //       //       time: '10.00 - 17.00',
            //       //   },

            //       //      {
            //       //       label: '1e Paasdag',
            //       //       time: 'gesloten',
            //       //   },
            //       // {
            //       //       label: '2e Paasdag',
            //       //       time: '12.00 - 16.00',
            //       //   },
            //       // {
            //       //       label: 'Koningsdag',
            //       //       time: 'gesloten',
            //       //   },
            //       // {
            //       //       label: 'Vanaf 1 mei',
            //       //       time: 'gesloten',
            //       //   },
            //       {
            //             label: '5 mei',
            //             time: 'gesloten',
            //         },
  
            //       //  {
            //       //       label: '23-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       // {
            //       //       label: '24-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '25-12-24 (1e)',
            //       //       label: '1e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '26-12-24 (2e)',
            //       //       label: '2e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //         // {
            //         //     label: '31-12-24',
            //         // label: 'Oudjaarsdag',
            //         //     time: '10.00 - 15.00',
            //         // },
            //       //   {
            //       //       // label: '01-01-25',
            //       //       label: 'Nieuwjaarsdag',
            //       //       time: 'gesloten',
            //       //   },
  
            //         {
            //             spacer: true
            //         },
            //         // {
            //         //     label: 'Za',
            //         //     time: '10.00 - 17.00',
            //         // },
            //         // {
            //         //     label: 'Zo',
            //         //     time: '1e zondag van de maand 12:00 - 16:00',
            //         // },
            //         {
            //             paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://goo.gl/maps/5pW4q7yJpbLiNPkz6" target="_blank">Route</a>',
            //             types: ['footer']
            //         },
            //         {
            //             paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-amsterdam">Feestdagen</a>',
            //             types: ['footer']
            //         },
            //     ],
            // },
            // {
            //     id: 'rotterdam-01',
            //     label: 'Oud-Beijerland',
            //     store_url: '/pages/showroom-oud-beijerland',
            //     name: 'Showroom Oud-Beijerland',
            //     description: '<p class="description">Pilotwinkel zonder personeel. Hier vind je alleen onze collectie:<br><a class="footer-btn" href="/collections/aanbieding-eettafels">Super Deals</a></p>',
            //     address: 'Julianastraat 45<br>3262 SH, Oud-Beijerland<br>Zuid-Holland',
            //     // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vr gesloten<br>Zat 10.00 - 17.00<br>1e zondag van de maand 12:00 - 16:00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-amsterdam">Feestdagen</a>',
            //     times: [
            //         {
            //             label: 'Ma',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Di',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Wo',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Do',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Vr',
            //             time: '08.00 - 22.00',
            //         },
            //       {
            //             label: 'Za',
            //             time: '08.00 - 22.00',
            //         },
            //       {
            //             label: 'Zo',
            //             time: '08.00 - 22.00',
            //         },

                  
                  
            //         //   {
            //         //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: #222;display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
            //         // },
  
            //       //  {
            //       //       label: '23-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       // {
            //       //       label: '24-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '25-12-24 (1e)',
            //       //       label: '1e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '26-12-24 (2e)',
            //       //       label: '2e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //         // {
            //         //     label: '31-12-24',
            //         // label: 'Oudjaarsdag',
            //         //     time: '10.00 - 15.00',
            //         // },
            //       //   {
            //       //       // label: '01-01-25',
            //       //       label: 'Nieuwjaarsdag',
            //       //       time: 'gesloten',
            //       //   },
  
            //         {
            //             spacer: true
            //         },
            //         // {
            //         //     label: 'Za',
            //         //     time: '10.00 - 17.00',
            //         // },
            //         // {
            //         //     label: 'Zo',
            //         //     time: '1e zondag van de maand 12:00 - 16:00',
            //         // },
            //         {
            //             paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/uNq4VKSDUqrV8cpz5" target="_blank">Route</a>',
            //             types: ['footer']
            //         },
            //         // {
            //         //     paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-amsterdam">Feestdagen</a>',
            //         //     types: ['footer']
            //         // },
            //     ],
            // },
            // {
            //     id: 'rotterdam-01',
            //     store_url: 'https://kas20.nl/pages/oud-beijerland',
            //     name: 'Superdeals Oud-Beijerland',
            //     description: '<p class="description">Pilotwinkel zonder personeel. Hier vind je alleen onze collectie:<br><a class="footer-btn" href="/collections/aanbieding-eettafels">Super Deals</a></p>',
            //     address: 'Julianastraat 45<br>3226 SH, Oud-Beijerland<br>Zuid-Holland',
            //     store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/frame-kiosk_1296x.jpg?v=1673453517',
            //     times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo 10.00 - 17.00 <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 17.00 <br>Zo 10.00 - 17.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/oud-beijerland">Feestdagen</a>',
            // },
          {
                id: 'maak-een-afspraak',
                label: 'Op afspraak',
                store_url: 'https://kas20.nl/pages/winkelafspraak',
                name: 'Bezoek op afspraak',
                description: '<p class="description">Wil je op afspraak langs komen? Dat kan altijd! Bel ons op <a href="tel:0202101966">020-2101966</a> of vul het <a href="https://kas20.nl/pages/contact-1">contactformulier</a> in.</p>',
                address: 'Te overleggen',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
                store_img: 'https://kas20.nl/cdn/shop/files/Screenshot_2023-11-01_at_08.54.15_720x.png?v=1698825268',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/meubel-showroom-bezoeken-almere">Feestdagen</a>',
                times: [
                    {
                        label: 'Ma',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Di',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Wo',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Do',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Vr',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Za',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Zo',
                        time: 'Op afspraak',
                    },
                    // {
                    //     paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                    // },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="tel:0202101966" target="_blank">Bellen</a>',
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="https://kas20.nl/pages/contact-1">Contact formulier</a>',
                    },
                ],
            },
        ]
  }